// extracted by mini-css-extract-plugin
export default {"section":"KB-z","sectionTitle":"LB-z","fieldWrapper":"MB-z","formField":"NB-z","disabled":"OB-z","formLabel":"PB-z"};